import React, { useState, useEffect } from "react";
import GaugeCardConsumer from "./GaugeCardConsumer";
import _consumerService from "../../../modules/consumerService";
import { Card, Row, Col, Typography, Divider, Space, Button, Tag, List, Spin, Modal, message, Tooltip, Table } from "antd";
import _commonService from "../../../modules/commonService";
import { BarChart, Bar, XAxis, YAxis, LabelList, Cell, ResponsiveContainer } from 'recharts';
import { RiseOutlined, DollarOutlined, DashboardOutlined } from "@ant-design/icons";

const { Text, Title } = Typography;

const AssessmentTabForConsumer = ({ activeKey }) => {
  const [loading, setLoading] = useState(false);
  const [assesmentInfo, setAssesmentInfo] = useState({});


  // Parse values for table
  const currentValueForTable = assesmentInfo && assesmentInfo.Current;
  const proFormaValueForTable = assesmentInfo && assesmentInfo.PostLoan;

  let currentPercentForTable = 'N/A', currentAmountForTable = 'N/A', proFormaPercentForTable = 'N/A', proFormaAmountForTable = 'N/A';
  if (currentValueForTable) {
    const [percent, amount] = currentValueForTable.split(', ');
    currentPercentForTable = percent ? percent.trim() : 'N/A';
    currentAmountForTable = amount ? amount.trim() : 'N/A';
  }
  if (proFormaValueForTable) {
    const [percent, amount] = proFormaValueForTable.split(', ');
    proFormaPercentForTable = percent ? percent.trim() : 'N/A';
    proFormaAmountForTable = amount ? amount.trim() : 'N/A';
  }


  useEffect(() => {
    if (activeKey && activeKey == "2") {
      getApplicantAssesmentInfoByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
      getApplicationStatusByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
    }
  }, [activeKey]);

  const getApplicationStatusByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getApplicationStatusByApplicationId(Number(applicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("isAllStepsCompleted", JSON.stringify(resObj?.applicationScreenStatus?.IsAllStepsCompleted));
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const getApplicantAssesmentInfoByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getApplicantAssesmentInfoByApplicationId(Number(applicationObjId));
      if (res.data) {
        let resObj = res.data.Obj;
        localStorage.setItem("ApplicantName", resObj.applicantGeneralInfoModel ? `${resObj.applicantGeneralInfoModel.FirstName || ""} ${resObj.applicantGeneralInfoModel.LastName || ""}`.trim() : "");

        setAssesmentInfo(resObj);
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // console.log("assesmentInfo", assesmentInfo);

  // const safeLimitValue = assesmentInfo && assesmentInfo.SafeLimit;
  const currentValue = assesmentInfo && assesmentInfo.Current;
  const proFormaValue = assesmentInfo && assesmentInfo.PostLoan;



  // Extract numeric part before %
  // const safeLimitPercent = parseFloat(safeLimitValue && safeLimitValue.split('%')[0]);
  const currentPercent = parseFloat(currentValue && currentValue.split('%')[0]);
  const proFormaPercent = parseFloat(proFormaValue && proFormaValue.split('%')[0]);

  // Calculate difference
  // const differencePercent = safeLimitPercent - currentPercent;

  const maxValue = Math.max(currentPercent, proFormaPercent, 1);


  const barData = [
    {
      name: 'Current',
      value: currentPercent,
      // safeLimitAmount: 400000,
      color: '#93C5FD',
    },
    {
      name: 'Pro-Forma',
      // safeLimit: safeLimitPercent,
      proForma: proFormaPercent,
      // currentAmount: 105000,
      // postLoanAmount: 500000,
    }
  ];

  const currentBarData = [
    { name: 'Current', value: currentPercent }
  ];

  const proFormaBarData = [
    { name: 'Pro-Forma', value: proFormaPercent }
  ];

  const makeCenteredData = (value) => [
    {
      name: 'bar',
      leftPad: (maxValue - value) / 2,
      value,
      rightPad: (maxValue - value) / 2
    }
  ];

  // const CustomTooltip = ({ active, payload }) => {
  //   if (!active || !payload) return null;
  //   const item = payload[0]?.payload;
  //   return (
  //     <div style={{ background: 'white', border: '1px solid #ccc', padding: 10 }}>
  //       <p><strong>{item.name}</strong></p>
  //       {item.value && <p>Safe Limit: 30%, ${item.safeLimitAmount && item.safeLimitAmount.toLocaleString()}</p>}
  //       {item.safeLimit && (
  //         <>
  //           <p>Current: 25%, ${item.currentAmount && item.currentAmount.toLocaleString()}</p>
  //           <p>Pro-Forma: 45%, ${item.postLoanAmount && item.postLoanAmount.toLocaleString()}</p>
  //         </>
  //       )}
  //     </div>
  //   );
  // };


  return (
    <Spin spinning={loading}>
      <div className="assessment-tab">
        {/* <Card className="iconFont chartbox-main-wrapper threebox margin5px">
        <Row >
          <Col
            className="gutter-row chartbox1"
          >
            <>
              <GaugeCardConsumer label="CBR Score" value={Number(assesmentInfo && assesmentInfo.CBRScore)} min={300} max={850} description={assesmentInfo && assesmentInfo.CBRScoreStaus} />
            </>
          </Col>
          <Col
            className="gutter-row chartbox1"
            gutter={[16, 16]}
          >
            <>
              <GaugeCardConsumer label="TDSR %" value={assesmentInfo && assesmentInfo.PFTDSR ? assesmentInfo.PFTDSR : "N/A"} min={0} max={100} unit=" %" description={assesmentInfo && assesmentInfo.TDSRStatus} />
            </>
          </Col>
          <Col
            className="gutter-row chartbox1"
          >
            <>
              <GaugeCardConsumer label="Leverage" value={assesmentInfo && assesmentInfo.Levrage ? assesmentInfo.Levrage : "N/A"} min={0} max={2} description={assesmentInfo && assesmentInfo.LevridgeStatus} />
            </>
          </Col>
        </Row>
      </Card> */}

        <Card className="iconFont chartbox-main-wrapper threebox margin5px key-metrics-card">
          <div className="chartbox-title">
            <DashboardOutlined className="chartbox-title-icon" />
            Key Metrics
          </div>

          <Row
            gutter={[16, 16]}
            justify="center"
            align="middle"
            className="metrics-row"
          >
            <Col
              xs={24}
              sm={12}
              md={8}
              className="chartbox1"
            >
              <GaugeCardConsumer
                label="CBR Score"
                value={assesmentInfo?.CBRScore}
                min={300}
                max={850}
                description={assesmentInfo?.CBRScoreStaus}
              />
            </Col>

            <Col
              xs={24}
              sm={12}
              md={8}
              className="chartbox1"
            >
              <GaugeCardConsumer
                label="TDSR %"
                value={assesmentInfo?.PFTDSR}
                min={0}
                max={100}
                unit="%"
                description={assesmentInfo?.TDSRStatus}
              />
            </Col>

            <Col
              xs={24}
              sm={12}
              md={8}
              className="chartbox1"
            >
              <GaugeCardConsumer
                label="Leverage"
                value={assesmentInfo?.Levrage}
                min={0}
                max={2}
                description={assesmentInfo?.LevridgeStatus}
              />
            </Col>
          </Row>
        </Card>




        <Row className="rowAlignNew iconFont ">
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card className="cardViewMain margin5px">
              <div className="chartbox-title">
                <RiseOutlined className="chartbox-title-icon" />
                Debt Proforma Impact
              </div>
              {/* <div>
              <BarChart
                layout="vertical"
                width={350}
                height={100}
                data={barData}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
                barCategoryGap={0}
                barGap={0}
              >
                <XAxis type="number" domain={[0, 50]} hide />
                <YAxis type="category" dataKey="name" width={100} />
                <Bar stackId="a" dataKey="value" barSize={30}>
                  {
                    barData && barData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color || '#00FFE0'} />
                    ))
                  }
                  <LabelList
                    dataKey="value"
                    position="right"
                    formatter={() => ""}
                    style={{ fill: '#000', fontWeight: 600 }}
                  />
                </Bar>
                <Bar dataKey="proForma" stackId="a" barSize={30} fill="#3B28CC">
                  <LabelList
                    dataKey="proForma"
                    position="right"
                    // formatter={(val) =>
                    //   `${val}%`
                    // }
                    formatter={() => ""}
                    style={{ fill: '#000', fontWeight: 600 }}
                  />
                </Bar>
              </BarChart>
            </div>
            <div style={{ fontSize: 14, lineHeight: '1.6', marginTop: 16, marginRight: 20 }}>
              {[
                // { label: 'Safe Limit', value: assesmentInfo?.SafeLimit, color: '#00FFE0' },
                { label: 'Current', value: assesmentInfo?.Current, color: '#93C5FD' },
                { label: 'Pro-Forma', value: assesmentInfo?.PostLoan, color: '#3B28CC' },
              ].map((item, idx) => (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                    marginBottom: 4,
                    alignItems: 'center'
                  }}
                >
                  <span className="mw80 spanColor">
                    <span style={{ color: item.color, marginRight: 6 }}>■</span>
                    {item.label}
                  </span>
                  <span>{item.value ?? 'N/A'}</span>
                </div>
              ))}
            </div>


            <div style={{ textAlign: 'center', marginTop: 16 }}>
              <div style={{ display: 'inline-grid', textAlign: 'left', fontSize: 14, lineHeight: '1.6' }}>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Total Debt Service ($)
                </span>
                <span className="spanColor">
                  <span style={{ marginRight: 8 }}>•</span>
                  Debt-to-Income Ratio (%)
                </span>
              </div>
            </div> */}

              <Table
                bordered={false}
                pagination={false}
                className="transparent-table assessment-table"
                columns={[
                  {
                    title: 'Metric',
                    dataIndex: 'metric',
                    key: 'metric',
                    render: text => <span className="spanColor">{text}</span>,
                  },
                  {
                    title: 'Current',
                    dataIndex: 'current',
                    key: 'current',
                  },
                  {
                    title: 'Pro-Forma',
                    dataIndex: 'proForma',
                    key: 'proForma',
                  },
                ]}
                dataSource={[
                  {
                    key: '1',
                    metric: 'Total Debt Service ($)',
                    current: currentAmountForTable,
                    proForma: proFormaAmountForTable,
                  },
                  {
                    key: '2',
                    metric: 'Debt-to-Income Ratio (%)',
                    current: currentPercentForTable,
                    proForma: proFormaPercentForTable,
                  },
                ]}
                showHeader={true}
                size="small"
              />

              <Row justify="center" gutter={32} className="responsivechartcontainer">

                {/* CURRENT */}
                <Col>
                  <div className="chartWrapperStyle">
                    <ResponsiveContainer width="100%" height={60}>
                      <BarChart
                        data={makeCenteredData(currentPercent)}
                        layout="vertical"
                        barCategoryGap={20}
                        barGap={0}
                        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                      >
                        <XAxis type="number" hide domain={[0, maxValue]} />
                        <YAxis type="category" hide />

                        {/* Left padding */}
                        <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                        {/* Actual bar */}
                        <Bar
                          dataKey="value"
                          stackId="a"
                          barSize={14}
                          radius={[8, 8, 0, 0]}
                          fill="rgba(244, 244, 245, 0.1)"
                          height={20}
                        />

                        {/* Right padding */}
                        <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                      </BarChart>
                    </ResponsiveContainer>

                    <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Current</div>
                    <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                      {currentValueForTable}
                    </div>
                  </div>
                </Col>


                {/* PRO-FORMA */}
                <Col>
                  <div className="chartWrapperStyle">
                    <ResponsiveContainer width="100%" height={60}>
                      <BarChart data={makeCenteredData(proFormaPercent)}
                        layout="vertical"
                        barCategoryGap={20}
                        barGap={0}
                        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
                      >
                        <XAxis type="number" hide domain={[0, maxValue]} />
                        <YAxis type="category" hide />

                        <Bar dataKey="leftPad" stackId="a" fill="transparent" />

                        <Bar
                          dataKey="value"
                          stackId="a"
                          barSize={20}
                          radius={[8, 8, 0, 0]}
                          fill="rgba(234, 179, 8, 1)"
                        />

                        <Bar dataKey="rightPad" stackId="a" fill="transparent" />
                      </BarChart>
                    </ResponsiveContainer>

                    <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>Pro-Forma</div>
                    <div style={{ color: 'rgba(244,244,245,0.7)', fontSize: 12 }}>
                      {proFormaValueForTable}
                    </div>
                  </div>
                </Col>


              </Row>

            </Card>
          </Col>

          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card
              className=" cardBodyPadding  FinancialSnapshotContainer  margin5px"

            >

              <div className="financial-header">
                <DollarOutlined />
                <span>Financial Snapshot</span>
              </div>



              <span>Total Debt Service</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalDebtService ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalDebtService)}` : "N/A"}</span>
              <Divider className="divider" />
              <span>Total Existing Debt</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalExistingDebt ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalExistingDebt)}` : "N/A"}</span>
              <Divider className="divider" />
              <span>Total Income</span><span className="fRight">{assesmentInfo && assesmentInfo.TotalIncome ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.TotalIncome)}` : "N/A"}</span>
              <Divider className="divider" />
              <span>Total Assets</span><span className="fRight">{assesmentInfo && assesmentInfo.AssetsValuation ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.AssetsValuation)}` : "N/A"}</span>
              <Divider className="divider" />
              <span>Net Worth</span><span className="fRight">{assesmentInfo && assesmentInfo.NetWorth ? `$ ${_commonService.formatNumberWithCommas(assesmentInfo.NetWorth)}` : "N/A"}</span>
              <Divider className="divider" />
              <span>Debt-to-Income Ratio</span><span className="fRight">{assesmentInfo && assesmentInfo.DebtIncomeRatio ? `${assesmentInfo.DebtIncomeRatio} %` : "N/A"}</span>
              {/* <Divider className="divider" /> */}
              {/* <span>Number Of Open Accounts</span><span className="fRight">{assesmentInfo && assesmentInfo.NumberOfOpenAccount ? assesmentInfo.NumberOfOpenAccount : "N/A"}</span> */}
              {/* <Divider style={{ margin: "8px 0" }} /> */}
              {/* <span>Hard Inquiries (12 Months)</span><span className="fRight">{assesmentInfo && assesmentInfo.HardEnquiry ? assesmentInfo.HardEnquiry : "N/A"}</span>
          // <Divider className="divider" />
          <span>Bankruptcy/Liens</span><span className="fRight">{assesmentInfo && assesmentInfo.Bankruptcy ? assesmentInfo.Bankruptcy : "N/A"}</span> */}
            </Card>
          </Col>

        </Row>
        {/* 
      <Card className="mb30 spanColor cardBorderShadow iconFont"
        title={
          <Row className="iconFont" align="middle" justify="space-between">
            <Text strong style={{ paddingTop: 0, marginLeft: "15px" }}> <FileTextOutlined /> Loan Program Details</Text>
            <Tooltip title="What is Loan Program Details?">
              <QuestionCircleOutlined className="ml10" />
            </Tooltip>
          </Row>
        }
      >
        <div className="alignment-padding">
          <Row gutter={32}>
            <Col span={12}>
              <div style={{ marginBottom: 12, marginLeft: "15px" }}>
                <Text type="secondary">Requested Loan Amount:</Text><br />
                <span>$ {assesmentInfo?.applicantionRiskFreeLoan?.LoanAmount ? _commonService.formatNumberWithCommas(assesmentInfo.applicantionRiskFreeLoan.LoanAmount) : "N/A"}</span>
              </div>
              <div style={{ marginLeft: "15px" }}>
                <Text type="secondary">Interest Rate:</Text><br />
                <span>{assesmentInfo?.applicantionRiskFreeLoan?.IntrestRate ? `${assesmentInfo.applicantionRiskFreeLoan.IntrestRate} %` : "N/A"}</span>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ marginLeft: "15px" }}>
                <Text type="secondary">Interest Rate:</Text><br />
                <span>{assesmentInfo?.applicantionRiskFreeLoan?.IntrestRate ? `${assesmentInfo.applicantionRiskFreeLoan.IntrestRate} %` : "N/A"}</span>
              </div>
              <div style={{ marginBottom: 12, marginLeft: "50px" }}>
                <Text type="secondary">Advance Rate:</Text><br />
                <span>{assesmentInfo?.applicantionRiskFreeLoan?.Advancerate ? `${assesmentInfo.applicantionRiskFreeLoan.Advancerate} %` : "N/A"}</span>
              </div>
              <div style={{ marginBottom: 12, marginLeft: "50px" }}>
                <Text type="secondary">Projected Interest Expense:</Text><br />
                <span>$ {assesmentInfo?.applicantionRiskFreeLoan?.ProjectedAnnualInterestExpense ? _commonService.formatNumberWithCommas(assesmentInfo.applicantionRiskFreeLoan.ProjectedAnnualInterestExpense) : "N/A"}</span>
              </div>
            </Col>
          </Row>
        </div>
      </Card> */}</div>
    </Spin>
  )
};

export default AssessmentTabForConsumer;